import { FaqAccordionItem } from './components/FaqAccordionItem';
import { FAQ_CATEGORIES } from './faq-content';

/**
 * US-019, verbatim. The approved mockup headed this page "FAQ" over a line about searching and
 * expanding questions, but it also carried the search field US-028 removed — so the acceptance
 * criteria are what this page is held to, not the mockup.
 */
const PAGE_TITLE = 'Frequently Asked Questions';
const INSTRUCTION_TEXT = 'Click the arrows to expand the answers to the questions.';

/**
 * FAQ (US-019, US-028). Accordion only — every item starts collapsed and there is no search field.
 *
 * US-028 is an open conflict: FRS-001 asks for a real-time search/filter, ARCH-OVW-001 v4.0 (the later
 * signature, which governs) removed it. Built accordion-only per that precedence; confirm with Bankers
 * Fidelity before adding search.
 */
export function FaqPage(): React.JSX.Element {
  return (
    <section aria-labelledby="faq-heading" className="flex flex-col gap-5">
      <header>
        <h1 id="faq-heading" className="text-brand-600 text-xl font-bold">
          {PAGE_TITLE}
        </h1>
        <p className="text-muted mt-1 text-sm">{INSTRUCTION_TEXT}</p>
      </header>

      {FAQ_CATEGORIES.map((category) => (
        <section
          key={category.name}
          aria-label={category.name}
          className="border-line rounded-xl border bg-surface p-6 shadow-sm"
        >
          <h2 className="text-brand-600 border-line border-b pb-3 text-lg font-bold">
            {category.name}
          </h2>

          <div className="mt-4 flex flex-col gap-2">
            {category.items.map((item) => (
              <FaqAccordionItem key={item.question} item={item} />
            ))}
          </div>
        </section>
      ))}
    </section>
  );
}
